import { useState, useEffect, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/layout/Sidebar';
import { Header } from '@/components/layout/Header';
import { MobileDrawer } from '@/components/layout/MobileDrawer';
import { NotificationStack } from '@/components/layout/NotificationStack';

const SIDEBAR_KEY = 'raios-sidebar-collapsed';

export function AppShell() {
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [manualCollapsed, setManualCollapsed] = useState(() => {
    try {
      return localStorage.getItem(SIDEBAR_KEY) === '1';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    const mqTablet = window.matchMedia('(min-width: 768px) and (max-width: 1023px)');

    const handleChange = () => {
      setIsTablet(mqTablet.matches);
    };

    handleChange();
    mqTablet.addEventListener('change', handleChange);
    return () => mqTablet.removeEventListener('change', handleChange);
  }, []);

  const sidebarCollapsed = isTablet || manualCollapsed;

  const toggleSidebar = useCallback(() => {
    setManualCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(SIDEBAR_KEY, next ? '1' : '0');
      } catch {
        // localStorage unavailable
      }
      return next;
    });
  }, []);

  return (
    <div className="flex h-dvh bg-raios-bg">
      {/* Desktop / Tablet sidebar · v13 (sessao 0415) · hamburger integrado ao rodape */}
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggleCollapsed={toggleSidebar}
        className="hidden md:flex"
      />

      {/* Mobile drawer */}
      <MobileDrawer
        open={mobileDrawerOpen}
        onClose={() => setMobileDrawerOpen(false)}
      />

      {/* Main area */}
      <div className="flex-1 flex flex-col min-w-0">
        <Header
          onMenuToggle={() => setMobileDrawerOpen(true)}
          onSidebarToggle={toggleSidebar}
          sidebarCollapsed={sidebarCollapsed}
        />

        <main id="main-content" className="flex-1 overflow-y-auto" aria-label="Conteudo principal">
          <div className="mx-auto max-w-screen-2xl px-4 py-4 md:px-6 md:py-6">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Notification stack — currently empty, children added in Phase 4 */}
      <NotificationStack />
    </div>
  );
}
